{
  "(optional)": "(προαιρετικό)",
  "(required)": "(απαιτείται)"
}
